import { Guid } from 'guid-typescript'

export type IterableListItem<T> = { guid: string, value: T }

export class IterableItemFactory {
  create<T>(value: T): IterableListItem<T> {
    return { 'guid': Guid.create().toString(), value }
  }
}
